export async function readSseStream(
  body: ReadableStream<Uint8Array>,
  onEvent: (event: { type: string; data: any }) => void,
  isClosed: () => boolean
): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  try {
    while (!isClosed()) {
      const result = await reader.read();
      if (result.done) break;
      buffer += decoder.decode(result.value, { stream: true });
      const events = buffer.split(/\r?\n\r?\n/);
      buffer = events.pop() || "";
      for (const raw of events) {
        if (isClosed()) break;
        let type = "message";
        const lines: string[] = [];
        raw.split(/\r?\n/).forEach(line => {
          if (line.startsWith("event:")) type = line.substring(6).trim();
          else if (line.startsWith("data:")) lines.push(line.substring(5).trim());
        });
        if (!lines.length) continue;
        let data: any = lines.join("\n");
        try { data = JSON.parse(data); } catch (_) {}
        onEvent({ type, data });
      }
    }
  } finally {
    reader.releaseLock();
  }
}
